export default __webpack_public_path__ + "static/bariol_serif_regular-webfont-99a43cb0c1b71cb0298e2dec6bd4eb02.woff";